import { NextPage } from "next";

import DashBoardTemplate from "@/components/page/dashboard/DashBoardTemplate";

const Index: NextPage = () => <DashBoardTemplate />;

export default Index;
